export default __webpack_public_path__ + "static/included-4-50b6aa1d77bcfb2fc695b14f82cc276a.png";